import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Translated from "../../../components/Translated/Translated";

function PrintForm(props) {
	return (
		<div className="quote-nav-component">
			<button className="quote-nav-top-link">
				<div></div>
				<Link className="print-link" target="_blank" to={{ pathname: "negotiations-print", search: `?projectId=${props.projectId}` }} exact>
					<Translated section="Misc" label="print" />
				</Link>
			</button>
		</div>
	);
}

const mapStateToProps = state => ({
	APIUrl: state.APIUrl,
	projectId: state.projectIdUsedToIncreaseProductQuantity
});

const mapDispatchToProps = {};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(PrintForm);
